import Symbol from "./Symbol";
import SymbolAnim from "./SymbolAnim";

export default class SymbolRed extends Symbol{
    constructor(commander, speed) {
        super(commander, speed);
    }

    init() {
        this.texture = PIXI.Texture.from("symbol_Red_particle.png");
    }

    startParticles(symbol) {
        return new Promise(res => {
            let pt = [
                {x: symbol.x, y: symbol.y},
                {x: symbol.x+25, y: symbol.y},
                {x: symbol.x-25, y: symbol.y-25}
            ];
            createjs.Tween.get()
                .wait(230*this.speed)
                .call(() => {
                    SymbolAnim.runEmitter(this.createBigEmitter(pt[0].x, pt[0].y));
                })
                .wait(600*this.speed)
                .call(() => {
                    this.createSpark(pt[1].x, pt[1].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[1].x, pt[1].y));
                })
                .wait(200*this.speed)
                .call(() => {
                    this.createSpark(pt[2].x, pt[2].y);
                    SymbolAnim.runEmitter(this.createSmallEmitter(pt[2].x, pt[2].y));
                })
                .call(() => {
                    res();
                });
        })
    }
}